import { z } from "zod";
import { LongText } from "./common.js";
/**
 * Problem Statement — Specify, singleton. Single text block; the Solve
 * title doubles as the bold headline so the schema only carries the
 * paragraph that frames the problem.
 */
export const ProblemStatementParamsSchema = z
    .object({
    problem: LongText,
})
    .strict();
export const defaultProblemStatementParams = {
    problem: "",
};
//# sourceMappingURL=problemStatement.js.map